import { LockClosedIcon } from "@";
import { useNavigate } from "react-router-dom";

export default function NotHavePermissions() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="relative overflow-hidden rounded-2xl bg-white/85 shadow-xl shadow-purple-900/5 ring-1 ring-purple-100 backdrop-blur-md dark:bg-gray-800/85 dark:shadow-black/30 dark:ring-purple-700/40">
          {/* Top accent stripe */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-purple-500/60 to-transparent"
          />

          {/* Icon band — design-system icon-chip pattern, scaled up */}
          <div className="flex h-32 items-center justify-center bg-gradient-to-b from-purple-50/30 to-transparent dark:from-purple-950/20">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-sm shadow-purple-900/20 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800">
              <LockClosedIcon className="h-5 w-5" />
            </span>
          </div>

          <div className="px-8 py-7 text-center">
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-purple-700 dark:text-purple-400">
              ٤٠٣ · ACCESS DENIED
            </p>
            <h1 className="mt-2 text-xl font-black tracking-tight text-gray-900 dark:text-gray-100 sm:text-2xl">
              ليس لديك صلاحية لعرض هذه الصفحة
            </h1>
            <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              تواصل مع المسؤول لمنحك الوصول إن كنت بحاجة إليها.
            </p>

            <div className="mt-6 flex flex-col items-center gap-3">
              <a href="/" className="btn-purple-900 !w-full justify-center">
                العودة للرئيسية
              </a>
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="text-sm font-medium text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
              >
                الرجوع للخلف
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
